import { useEffect } from 'react';

/**
 * Landing page component - always redirects to /app with URL parameters preserved.
 */
export const Landing = () => {
    useEffect(() => {
        // Redirect to /app and preserve query parameters
        const queryParams = window.location.search;
        window.location.href = `/app${queryParams}`;
    }, []);

    return null;
};
